import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./app/app";
import "./i18n/i18n";
import {DamageLocation, EquipmentType} from "./transportation/models/tcr";

declare global {
    interface EventTarget {
        svgClick: (event: React.MouseEvent, equipmentType?: EquipmentType, damageLocation?: DamageLocation) => void;
    }
}


ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById("root")
);

